module.exports = __webpack_public_path__ + "static/media/lloyds-pg2.63fdc29e.jpg";